import {createFileRoute} from '@tanstack/react-router';
import {makeApiSortParam} from 'shared';

import {assetKeys} from '@/features/Asset/api/queryKeys';
import {getAsset} from '@/features/Asset/api/readAsset';
import {AssetProfile} from '@/features/Asset/components/AssetProfile';
import {
  categoryKeys,
  severityScaleKeys,
} from '@/features/Library/api/queryKeys';
import {getCategories} from '@/features/Library/api/readCategories';
import {getSeverityScaleByAsset} from '@/features/Library/api/readSeverityScaleByAsset';
import {userKeys} from '@/features/User/api/queryKeys';
import {getUsers} from '@/features/User/api/readUsers';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/assets/$assetId')({
  component: AssetProfile,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.assetId);

    const categoryFilter = {
      assetId: params.assetId,
      orderBy: makeApiSortParam([
        {prop: 'isArchived', isAsc: true},
        {prop: 'hasAi', isAsc: false},
        {prop: 'name', isAsc: true},
      ]),
    };

    return {
      ...context,
      readAssetQuery: {
        queryKey: assetKeys.detail(params.assetId),
        queryFn: () => getAsset(params.assetId),
      },
      readUsersQuery: {
        queryKey: userKeys.list({assetId: params.assetId}),
        queryFn: () => getUsers({assetId: params.assetId}),
      },
      readSeverityScaleQuery: {
        queryKey: severityScaleKeys.detail(params.assetId),
        queryFn: () => getSeverityScaleByAsset(params.assetId),
      },
      readCategoriesQuery: {
        queryKey: categoryKeys.list(categoryFilter),
        queryFn: () => getCategories(categoryFilter),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readAssetQuery),
      context.queryClient.ensureQueryData(context.readUsersQuery),
      context.queryClient.ensureQueryData(context.readSeverityScaleQuery),
      context.queryClient.ensureQueryData(context.readCategoriesQuery),
    ]);
  },
});
